// Owl Carousels
if (window.jQuery) {
    $ = jQuery;
    var owlOne = $('.owl-carousel-tab1');
    var owlTwo = $('.owl-carousel-tab2');
    var owl = $('.owl-carousel');

    if (owlOne.length > 0) {
        owlOne.owlCarousel({
            items: 1,
            lazyLoad: true,
            loop: true,
            autoplay: false,
            margin: 0,
            dots: true,
            nav: true,
            navText: ['<span class="fa fa-angle-left"></span>', '<span class="fa fa-angle-right"></span>'],
            navContainer: '.owl-carousel-tab1',
            onTranslated: function () {
                // Remove any previously added tab index so that hitting tab again will go to prev or next buttons
                $('.owl-carousel-tab1').find('.owl-item').removeAttr('tabindex');
                // Add tab index of 0, then focus to the item for screenreader to read
                $('.owl-item.active').attr('tabindex', 0).focus();
            },

            onInitialized: function () {
                $('.owl-carousel-tab1').find('.owl-prev').attr('role', 'button').attr('title', 'Previous');
                $('.owl-carousel-tab1').find('.owl-next').attr('role', 'button').attr('title', 'Next');
                // Remove the presentation role for the previous and next chevron elements for A11y.
                $('.owl-carousel-tab1').find('.owl-prev').removeAttr('role');
                $('.owl-carousel-tab1').find('.owl-next').removeAttr('role');
            }
        });
    }

    if (owlTwo.length > 0) {
        owlTwo.owlCarousel({
            items: 1,
            lazyLoad: true,
            loop: true,
            autoplay: false,
            margin: 0,
            dots: true,
            nav: true,
            navText: ['<span class="fa fa-angle-left"></span>', '<span class="fa fa-angle-right"></span>'],
            navContainer: '.owl-carousel-tab2',
            onTranslated: function () {
                // Remove any previously added tab index so that hitting tab again will go to prev or next buttons
                $('.owl-carousel-tab2').find('.owl-item').removeAttr('tabindex');
                // Add tab index of 0, then focus to the item for screenreader to read
                $('.owl-item.active').attr('tabindex', 0).focus();
            },

            onInitialized: function () {
                $('.owl-carousel-tab2').find('.owl-prev').attr('role', 'button').attr('title', 'Previous');
                $('.owl-carousel-tab2').find('.owl-next').attr('role', 'button').attr('title', 'Next');
                // Remove the presentation role for the previous and next chevron elements for A11y.
                $('.owl-carousel-tab2').find('.owl-prev').removeAttr('role');
                $('.owl-carousel-tab2').find('.owl-next').removeAttr('role');
            }
        });
    }

    if (owl.length > 0) {
        owl.owlCarousel({
            items: 1,
            lazyLoad: true,
            loop: true,
            autoplay: false,
            margin: 0,
            dots: true,
            nav: true,
            navText: ['<span class="fa fa-angle-left"></span>', '<span class="fa fa-angle-right"></span>'],
            navContainer: '.owl-carousel',
            onTranslated: function () {
                // Remove any previously added tab index so that hitting tab again will go to prev or next buttons
                $('.owl-carousel').find('.owl-item').removeAttr('tabindex');
                // Add tab index of 0, then focus to the item for screenreader to read
                $('.owl-item.active').attr('tabindex', 0).focus();
            },

            onInitialized: function () {
                $('.owl-carousel').find('.owl-prev').attr('role', 'button').attr('title', 'Previous button');
                $('.owl-carousel').find('.owl-next').attr('role', 'button').attr('title', 'Next');
                // Remove the presentation role for the previous and next chevron elements for A11y.
                $('.owl-carousel').find('.owl-prev').removeAttr('role');
                $('.owl-carousel').find('.owl-next').removeAttr('role');
            }

        });

    }

    //Find each set of dots in this carousel
    //Go through each carousel on the page and add a slide number to the aria label for A11y.
    $('.owl-carousel').each(function () {
        //Find each set of dots in this carousel
        $(this).find('.owl-dot').each(function (index) {
            //Add one to index so it starts from 1
            $(this).attr('aria-label', index + 1);
        });
    });

}
